import React, { FC, memo, useCallback, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { encodeToBase64 } from '../../../../../utils/encoding-utils'
import { FilterItemTransport } from '../../../../../transports/filters-configuration-transport'
import { Pill } from './pill-filter-styles'
import { filterGATracking } from '../../utils'
import { FilterType } from '../../types'
import { filterClick, getFilterError, getRegionNodeId } from '../../../../../redux/filters'

import { Dispatch } from '../../../../../redux/types'
import { useRequestUserConfigContext } from '../../../../../hooks/request'

type Props = {
    filterItem: FilterItemTransport
    filterType: FilterType
}

const PillFilterItem: FC<Props> = ({ filterItem, filterType }) => {
    const dispatch = useDispatch<Dispatch>()
    const error = useSelector(getFilterError)
    const regionNodeId = useSelector(getRegionNodeId)
    const user = useRequestUserConfigContext()
    const [isChecked, setIsChecked] = useState<boolean>(filterItem.checked)

    const handleClick = useCallback(() => {
        filterGATracking({
            type: filterType,
            name: filterItem.title,
            value: filterItem.value,
            isChecked: !isChecked,
            regionNodeId,
        })
        setIsChecked(!isChecked)
        const filterItemUrl = new URL(filterItem.absoluteLink)
        dispatch(filterClick(encodeToBase64(filterItemUrl.pathname + filterItemUrl.search), false, user))
    }, [filterItem, filterType, isChecked, dispatch, regionNodeId, user])

    useEffect(() => {
        setIsChecked(filterItem.checked)
    }, [filterItem, error])

    return (
        <Pill selected={isChecked} onClick={handleClick}>
            {filterItem.title}
        </Pill>
    )
}

export default memo(PillFilterItem)
